<div *ngIf="booking">
  ID: {{booking.id}}
  First name: {{booking.student.firstName}}
  Last name: {{booking.student.lastName}}
  Start: {{booking.startDate | dateFormat: "DD/MM/YYYY"}}
  End: {{booking.endDate | dateFormat: "DD/MM/YYYY"}}
</div>
<div *ngIf="pictureLoaded">
  <img [src]="showPicture" class="student-picture">
</div>

<div *ngIf="booking">
  post picture here
  <input type="file" id="file" accept="image/*" (change)="handleFileInput($event)">
  <!-- <button (click)="uploadFile()" *ngIf="!pictureLoaded">
    upload
  </button> -->

  <!-- <button *ngIf="pictureLoaded" (click)="updateFile()">
    update
  </button> -->

</div>